(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var DELAY = 6000;
  var ACTIVE = 'buffalo-banner-rotator__slide--active';

  function init(root) {
    if (root.dataset.bfReady) return;
    if (window.bfFabrica) window.bfFabrica.addToRotator(root);
    var slides = [].slice.call(root.querySelectorAll('.buffalo-banner-rotator__slide'));
    if (slides.length < 2) return;
    root.dataset.bfReady = '1';

    var index = 0;
    var timer = null;
    var hovering = false;
    var inView = false;

    var dots = document.createElement('div');
    dots.className = 'buffalo-banner-rotator__dots';
    slides.forEach(function (_, n) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Ver banner ' + (n + 1) + ' de ' + slides.length);
      b.addEventListener('click', function () {
        go(n);
        schedule();
      });
      dots.appendChild(b);
    });
    root.appendChild(dots);
    var buttons = dots.children;

    function go(n) {
      slides[index].classList.remove(ACTIVE);
      buttons[index].removeAttribute('aria-current');
      if (window.bfFabrica) window.bfFabrica.playVideo(slides[index], false);
      index = n;
      slides[index].classList.add(ACTIVE);
      buttons[index].setAttribute('aria-current', 'true');
      if (window.bfFabrica && inView && !reduce.matches) window.bfFabrica.playVideo(slides[index], true);
    }

    function stop() {
      clearTimeout(timer);
      timer = null;
      if (window.bfFabrica && !inView) window.bfFabrica.playVideo(slides[index], false);
    }

    function schedule() {
      stop();
      if (reduce.matches || hovering || !inView || document.hidden) return;
      timer = setTimeout(function () {
        go((index + 1) % slides.length);
        schedule();
      }, slides[index].querySelector('video') ? DELAY + 3000 : DELAY);
    }

    root.addEventListener('mouseenter', function () { hovering = true; stop(); });
    root.addEventListener('mouseleave', function () { hovering = false; schedule(); });
    root.addEventListener('focusin', function () { hovering = true; stop(); });
    root.addEventListener('focusout', function () { hovering = false; schedule(); });
    document.addEventListener('visibilitychange', schedule);
    reduce.addEventListener && reduce.addEventListener('change', schedule);

    buttons[0].setAttribute('aria-current', 'true');

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
        if (window.bfFabrica) window.bfFabrica.playVideo(slides[index], inView && !reduce.matches);
        schedule();
      }, { threshold: 0.4 }).observe(root);
    } else {
      inView = true;
      schedule();
    }
  }

  [].forEach.call(document.querySelectorAll('.buffalo-banner-rotator'), init);
})();
